import { Injectable, Inject } from '@angular/core';
import { Observable, Subject, filter, interval, of, single, takeUntil, takeWhile, timeInterval, endWith } from 'rxjs';

@Injectable()
export class AsyncService {

  constructor() { } 

  waitUntil = (timeout: number, condition: () => boolean, func: () => void, cancellationToken: Subject<void> = new Subject<void>): void => {
    const event = interval(timeout)
      .pipe(        
        filter(_ => condition()),
        takeUntil(cancellationToken)
      )
      .subscribe(_ => {
        func();
        event.unsubscribe();
      });
  }

  createCancelationToken = (): Subject<void> => new Subject<void>();

  ///Use it when component destroing to close all async events
  dispose = (token: Subject<void>): void => {
    token.next();
    token.complete();
  }


}
